import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["fullWidth"],
  _excluded2 = ["classes", "disabled", "isVertical", "fieldState", "items", "message", "required"],
  _excluded3 = ["value"];
import React from "react";
import { BasicRadioGroup, asField } from "informed";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { Message } from "@magento/venia-ui/lib/components/Field";
import Radio from "./radio";
import defaultClasses from "./radioGroup.module.scss";
const RadioGroup = _ref => {
  let {
      fullWidth = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
      classes: propClasses,
      disabled,
      isVertical,
      fieldState,
      items,
      message,
      required
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const classes = mergeClasses(defaultClasses, propClasses);
  const options = items.map(_ref2 => {
    let {
        value
      } = _ref2,
      item = _objectWithoutProperties(_ref2, _excluded3);
    return /*#__PURE__*/React.createElement(Radio, _extends({
      disabled: disabled
    }, item, {
      classes: {
        label: classes.radioLabel,
        root: classes.radioContainer
      },
      key: value,
      value: value,
      fullWidth: fullWidth
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "radioGroupContainer section-full-rounded ".concat(isVertical ? classes.isVertical : classes.isHorizontal)
  }, /*#__PURE__*/React.createElement(BasicRadioGroup, _extends({}, rest, {
    fieldState: fieldState
  }), options)), /*#__PURE__*/React.createElement(Message, {
    className: classes.message,
    fieldState: fieldState
  }, message));
};
export default asField(RadioGroup);